import axios from "axios";
import {API} from "@/services/url";

export default {
	getAllDepartments : function (officeId, success, error){
		console.log(officeId);
		axios.get(API.department.all+officeId)
			.then(r => success(r.data.departmentList))
			.catch(e => error(e.response.data.message));
	}
}
